import { message } from '@tencent/spaui';
import qs from 'qs';
export * from './actionReport/const';
export * from './actionReport/ZhbActionReporter';
export * from './actionReport/type';
export var zhbErrorToast = function zhbErrorToast(msg, duration, option) {
  var traceError = new Error().stack || "trace_fail: ".concat(msg);
  console.error("catch zhbErrorToast: ".concat(traceError));
  message.error(msg, duration, option);
};
export var copyTextToClipboard = function copyTextToClipboard(option) {
  var text = option.text,
    _option$showSuccessTi = option.showSuccessTip,
    showSuccessTip = _option$showSuccessTi === void 0 ? true : _option$showSuccessTi,
    _option$successTipCon = option.successTipContext,
    successTipContext = _option$successTipCon === void 0 ? '复制成功' : _option$successTipCon;
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    var textarea = document.createElement('textarea');
    document.body.appendChild(textarea);
    textarea.style.position = 'fixed';
    textarea.style.clip = 'rect(0 0 0 0)';
    textarea.style.top = '10px';
    textarea.value = text;
    textarea.select();
    document.execCommand('copy', true);
    document.body.removeChild(textarea);
  }
  if (showSuccessTip) {
    message.success(successTipContext);
  }
};
export var isWecomMock = function isWecomMock() {
  var _qs$parse = qs.parse(window.location.search.slice(1)),
    mock = _qs$parse.mock;
  return !!mock;
};
export var isWecomDebug = function isWecomDebug() {
  var _qs$parse2 = qs.parse(window.location.search.slice(1)),
    debug = _qs$parse2.debug;
  return !!debug;
};